"use server";

import { cookies } from "next/headers";
import { revalidatePath } from "next/cache";
import { LOCALE_COOKIE, isLocale } from "@/lib/i18n/types";

/**
 * Troca o idioma da interface.
 *
 * Não toca em banco nem em service — é preferência de apresentação, guardada em cookie.
 * Por isso NÃO usa `withTenant`: não há data fetching por tenant nesta action.
 * Cookie só pode ser escrito em Server Action ou Route Handler, nunca em Server Component.
 */
export async function setLocale(value: string): Promise<{ ok: boolean }> {
    if (!isLocale(value)) return { ok: false };

    (await cookies()).set(LOCALE_COOKIE, value, {
        path: "/",
        maxAge: 60 * 60 * 24 * 365,
        sameSite: "lax",
        httpOnly: false, // preferência de UI, não credencial — sem segredo aqui
    });

    revalidatePath("/", "layout");
    return { ok: true };
}
